import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const SpacesManageRoute = lazyWithRetries(() => import('.'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.admin.spacesManage(':tab?'),
    element: (
      <StandardPageLayout elementId="spacesManageRoute" title={<T _str="Spaces" />} maxWidth={1440}>
        <Suspense fallback={<RouteLoading />}>
          <SpacesManageRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
